import { render } from "./GuestLayout.vue?vue&type=template&id=1ec1a3de"
import script from "./GuestLayout.vue?vue&type=script&lang=js"
export * from "./GuestLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/demit/Projects/SMS-Syariah/server/app/business/sms-pay-business/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__